/**
 * @store 权限模块
 */

import {api} from "@/api";
import _ from 'lodash';
import {userInfoBase} from "@/utils/types";
import config from '@/config';
import {getLocalBank, removeLocalBank, setLocalBank} from "@/utils/storage";

const LOCAL_TOKEN_SYMBOL = `${config.storagePre}_LOGIN_TOKEN`;

export default {
  namespaced: true,
  state: {
    token: '',
    userInfo: {
      ...userInfoBase,
    }
  },
  getters: {
    logged: state => !_.isEmpty(state.token),
    userInfo: state => state.userInfo,
  },
  mutations: {
    ['SET_TOKEN'] (state, token) {
      state.token = token;
      setLocalBank(LOCAL_TOKEN_SYMBOL, token);
    },
    ['CLEAR_TOKEN'] (state) {
      state.token = '';
      removeLocalBank(LOCAL_TOKEN_SYMBOL);
    },
    ['RECOVERY_TOKEN'](state) {
      state.token = getLocalBank(LOCAL_TOKEN_SYMBOL);
    },
    ['SET_USER_INFO'] (state, data) {
      state.userInfo = {...data};
    },
    ['CLEAR_USER_INFO'] (state) {
      state.userInfo = {...userInfoBase};
    },
  },
  actions: {
    async signIn({commit}, data) {
      const result = await api.post(`/api/user/login`, data);
      if (result.code === 1) {
        commit('SET_TOKEN', result.token);
      }
      return result;
    },
    async mobileAuth({commit}, data) {
      const result = await api.post(`/api/user/mobileAuth`, data);
      if (result.code === 1) {
        commit('SET_TOKEN', result.token);
      }
      return result;
    },
    async signUp(_, data) {
      return await api.post(`/api/user/register`, data);
    },
    async verify(_, data) {
      return await api.post(`/api/user/verify?random=${data.random}`);
    },
    async getCaptcha(_, data) {
      return await api.post(`/api/user/getVerificationCode`, data);
    },
    async queryUserInfo({state, commit}) {
      const result = await api.post(`/api/user/getProfile`, {
        token: state.token,
      });
      if (result.code === 1) {
        commit('SET_USER_INFO', result.data);
      }
      return result;
    },
  },
}
